import { env, Env } from 'core/config';
import { AtsProvider, IntegrationCredentials } from '../types';

export const getAtsJobUrl = ({
  integrationCredentials,
  atsJobId
}: {
  integrationCredentials: IntegrationCredentials | null;
  atsJobId: string | null | undefined;
}) => {
  if (!integrationCredentials || !atsJobId) {
    return null;
  }

  const { appSubdomain, provider } = integrationCredentials;

  switch (provider) {
    case AtsProvider.greenhouse:
      if (!appSubdomain) return;
      return `https://${appSubdomain}.greenhouse.io/sdash/${atsJobId}`;

    case AtsProvider.pinpoint:
      if (!appSubdomain) return;
      return `https://${appSubdomain}.pinpointhq.com/admin/jobs/${atsJobId}/applications`;

    case AtsProvider.bullhorn_ats:
    case AtsProvider.bullhorn:
      if (!appSubdomain) return;
      return `https://${appSubdomain}.bullhornstaffing.com/BullhornSTAFFING/OpenWindow.cfm?Entity=JobOrder&id=${atsJobId}`;

    case AtsProvider.lever:
      return `https://hire.${
        env.STAGE === Env.dev ? 'sandbox.' : ''
      }lever.co/jobs/postings/edit/${atsJobId}`;

    case AtsProvider.logic_melon:
      return `https://appuser.logicmelon.com/VacancyMPATS/OldViewAdvert/${atsJobId}`;
  }
};
